/* =========================================================
   ORANGE JUNGLE – ZENTRALE SUCHVORSCHLÄGE
   Wird von Predictive Search und Main Search verwendet
   ========================================================= */

window.OJ_SEARCH_SUGGESTIONS = [
  // Marken / zentrale Einstiege
  'adidas',
  'adidas Samba',
  'adidas Superstar',
  'adidas Gazelle Indoor',
  'Nike',
  'Nike Air Force 1',
  'Nike Air Max',
  'New Balance',
  'ASICS',
  'Salomon',
  'Birkenstock',
  'Carhartt WIP',
  'The North Face',
  'Dr. Martens',

  // Nike
  'Air Force 1',
  'Air Max 1',
  'Air Max 90',
  'Air Max 95',
  'Air Max 97',
  'Air Max Plus',
  'Air Max DN',
  'Dunk Low',
  'Dunk High',

  // adidas
  'Samba',
  'Samba OG',
  'Samba XLG',
  'Superstar',
  'Gazelle Indoor',
  'Handball Spezial',
  'Campus 00s',
  'SL 72',

  // ASICS
  'GEL-1130',
  'GEL-NYC',
  'GEL-Kayano 14',
  'GEL-Kayano 20',
  'GT-2160',
  'GEL-Venture 6',

  // Salomon
  'XT-6',
  'XT-4',
  'XT-Whisper',
  'XT-Pathway',
  'ACS Pro',
  'XA Pro 3D',

  // New Balance
  'New Balance 530',
  'New Balance 574',
  'New Balance 740',
  'New Balance 9060',
  'New Balance 1906',
  'New Balance 2002R',

  // Birkenstock
  'Arizona',
  'Arizona EVA',
  'Boston',
  'Boston EVA',

  // Themen / Kampagnen
  'DFB',
  'DFB Trikot',
  'DFB 94',
  'DFB EQT',
  'Running',
  'Skateboarding'
];